import React from 'react';
import './EtudiantEtrangerEnFrance.css';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import {
  FaHandshake,
  FaFileAlt,
  FaGraduationCap,
  FaBriefcase,
  FaTools,
  FaBalanceScale,
  FaUsers,
  FaBullseye,
  FaHome,
  FaFacebook,
  FaLinkedin,
  FaHandsHelping,
  FaUserFriends,
  FaCommentDots,
  FaShieldAlt,
  FaCheckCircle
} from 'react-icons/fa';

const EtudiantEtrangerEnFrance = () => {
  const freeServices = [
    { 
      icon: <FaHandshake />, 
      title: 'Aide à l\'intégration en France', 
      desc: 'Accompagnement pour s\'adapter à la vie en France' 
    },
    { 
      icon: <FaFileAlt />, 
      title: 'Renouvellement du titre de séjour', 
      desc: 'Assistance complète pour le renouvellement de votre titre de séjour' 
    },
    { 
      icon: <FaGraduationCap />, 
      title: 'Orientation académique', 
      desc: 'Conseils pour réorientations ou reprises d\'études' 
    },
    { 
      icon: <FaBriefcase />, 
      title: 'Job étudiant', 
      desc: 'Aide à la recherche d\'emplois étudiants' 
    },
    { 
      icon: <FaTools />, 
      title: 'Stage et Alternance', 
      desc: 'Accompagnement pour trouver des stages et contrats d\'alternance' 
    },
    { 
      icon: <FaBalanceScale />, 
      title: 'Soutien administratif et juridique', 
      desc: 'Assistance pour les démarches administratives et juridiques' 
    },
    { 
      icon: <FaUsers />, 
      title: 'Programmes de mentorat', 
      desc: 'Accompagnement social et mentorat par des experts' 
    },
    { 
      icon: <FaBullseye />, 
      title: 'Ateliers experts', 
      desc: 'Logement, emploi, santé, vie étudiante, alternance, entreprenariat' 
    }
  ];

  return (
    <section className="student-in-france-sectionbigcontain">
      <Header />
      <section className="student-in-france-section">
        <div className="student-in-france-canvas">
          <div className="student-in-france-decoration">
            {/* Particules françaises */}
            <div className="france-particle france-particle-1"></div>
            <div className="france-particle france-particle-2"></div>
            <div className="france-particle france-particle-3"></div>
            <div className="france-particle france-particle-4"></div>
            
            {/* Lignes françaises */}
            <div className="france-line france-line-1"></div>
            <div className="france-line france-line-2"></div>
            
            {/* Orbes français */}
            <div className="france-glow-orb france-orb-1"></div>
            <div className="france-glow-orb france-orb-2"></div>
            <div className="france-glow-orb france-orb-3"></div>
          </div>
        </div>

        <div className="student-in-france-wrapper">
          <div className="student-in-france-header">
            <h1 className="student-in-france-title">
              Étudiant étranger déjà en France
              <span className="student-in-france-free-badge">
                <FaCheckCircle style={{ marginRight: '8px' }} />
                Services GRATUITS
              </span>
            </h1>
            <div className="student-in-france-line">
              <div className="student-in-france-line-glow"></div>
            </div>
            <p className="student-in-france-intro">
              Services assurés par notre association : <span className="student-in-france-highlight">L'Étudiant Étranger – ETEF</span>
            </p>
          </div>

          <div className="student-in-france-services-grid">
            {freeServices.map((service, index) => (
              <div 
                key={index} 
                className="student-in-france-service-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="student-in-france-service-icon">
                  {service.icon}
                </div>
                <h3 className="student-in-france-service-title">{service.title}</h3>
                <p className="student-in-france-service-desc">{service.desc}</p>
              </div>
            ))}
          </div>

          <div className="student-in-france-objective-box">
            <div className="student-in-france-objective-icon">
              <FaShieldAlt />
            </div>
            <h2 className="student-in-france-objective-title">Notre Objectif</h2>
            <p className="student-in-france-objective-text">
              <FaCommentDots style={{ marginRight: '10px' }} />
              Sécuriser la vie des étudiants en France et les accompagner jusqu'à la réussite de leur parcours.
            </p>
          </div>

          <div className="student-in-france-action-buttons">
            <a
              href="https://facebook.com"
              className="student-in-france-btn student-in-france-facebook-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebook className="btn-icon" />
              Intégrer la communauté Facebook
            </a>
            
            <a
              href="https://votreplateforme.com"
              className="student-in-france-btn student-in-france-community-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaUserFriends className="btn-icon" />
              Intégrer la plateforme d'entraide
            </a>
            
            <a
              href="https://linkedin.com"
              className="student-in-france-btn student-in-france-linkedin-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin className="btn-icon" />
              Nous rejoindre sur LinkedIn
            </a>
          </div>
        </div>
      </section>
      <Footer />
    </section>
  );
};

export default EtudiantEtrangerEnFrance;